import Glide, { Breakpoints, Controls, Swipe, Images } from '@glidejs/glide/dist/glide.modular.esm';
import { getDir } from '../../common/components/utils/utils';

const SELECTORS = {
	root: '[data-slider-partners]',
};

export class PartnersSlider {
	constructor() {
		this.rootEl = document.querySelector(SELECTORS.root);

		const requiredElements = [this.rootEl];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new PartnersSlider();
	}

	setupSlider() {
		this.slider = new Glide(this.rootEl, {
			type: 'carousel',
			perView: 4,
			gap: 32,
			rewind: false,
			direction: getDir(),
			animationTimingFunc: 'linear',
			swipeThreshold: 40,
			breakpoints: {
				1000: {
					perView: 2,
					gap: 24,
				},
				600: {
					perView: 1.2,
					gap: 16,
				},
			},
		}).mount({ Controls, Breakpoints, Swipe, Images });
	}

	setup() {
		this.setupSlider();
	}
}
